<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 16.9756C20 20.3026 17.2759 23 13.916 23H10.084C6.72408 23 4 20.3026 4 16.9756V12H20V16.9756Z" :fill="`url(#${componentId}_paint0_linear_4224_1631)`" />
    <foreignObject
      x="3.66275"
      y="1.66275"
      width="16.6745"
      height="8.67451"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(0.17px); clip-path: url(#${componentId}_bgblur_0_4224_1631_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <path
      data-figma-bg-blur-radius="0.337255"
      d="M15.3262 2.33398C16.1945 2.18268 16.9693 2.21911 17.458 2.57715C18.4607 3.31206 18.5676 4.54422 18.5693 4.56445L18.5703 4.58203L18.5742 4.59863L19.6904 9.75H4.30957L5.42578 4.59863L5.42969 4.58203L5.43066 4.56445C5.43234 4.54439 5.53922 3.31211 6.54199 2.57715C7.03072 2.21911 7.8055 2.18268 8.67383 2.33398C9.52732 2.48271 10.4021 2.79991 11.0273 3.06152C11.6502 3.32206 12.3498 3.32206 12.9727 3.06152C13.5979 2.79991 14.4727 2.48271 15.3262 2.33398Z"
      fill="#FF749F"
      fill-opacity="0.48"
      :stroke="`url(#${componentId}_paint1_linear_4224_1631)`"
      stroke-width="0.5"
    />
    <foreignObject
      x="1.66275"
      y="12.6627"
      width="20.6745"
      height="6.67451"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(0.17px); clip-path: url(#${componentId}_bgblur_1_4224_1631_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <path
      data-figma-bg-blur-radius="0.337255"
      d="M3.13477 13.25H20.8652C21.3713 13.25 21.7498 13.6271 21.75 14.0547V14.9121C21.75 15.9237 21.3178 16.8978 20.542 17.6191C19.7654 18.3411 18.7081 18.75 17.6025 18.75C16.4971 18.7499 15.4406 18.341 14.6641 17.6191C13.8882 16.8978 13.4561 15.9238 13.4561 14.9121V14.6621H10.5439V14.9121C10.5439 15.9238 10.1118 16.8978 9.33594 17.6191C8.55943 18.341 7.5029 18.7499 6.39746 18.75C5.29192 18.75 4.23459 18.3411 3.45801 17.6191C2.68223 16.8978 2.25001 15.9237 2.25 14.9121V14.0547C2.25015 13.6271 2.62875 13.25 3.13477 13.25Z"
      fill="#A31843"
      fill-opacity="0.48"
      :stroke="`url(#${componentId}_paint2_linear_4224_1631)`"
      stroke-width="0.5"
    />
    <foreignObject
      x="0.662745"
      y="9.66275"
      width="22.6745"
      height="2.67451"
    ><div
      xmlns="http://www.w3.org/1999/xhtml"
      :style="`backdrop-filter: blur(0.17px); clip-path: url(#${componentId}_bgblur_2_4224_1631_clip_path); height: 100%; width: 100%`"
    /></foreignObject>
    <path
      data-figma-bg-blur-radius="0.337255"
      d="M2 10.25H22C22.4142 10.25 22.75 10.5858 22.75 11C22.75 11.4142 22.4142 11.75 22 11.75H2C1.58579 11.75 1.25 11.4142 1.25 11C1.25 10.5858 1.58579 10.25 2 10.25Z"
      fill="#FF749F"
      fill-opacity="0.48"
      :stroke="`url(#${componentId}_paint3_linear_4224_1631)`"
      stroke-width="0.5"
    />
    <defs>
      <clipPath :id="`${componentId}_bgblur_0_4224_1631_clip_path`" transform="translate(-3.66275 -1.66275)">
        <path
          d="M15.3262 2.33398C16.1945 2.18268 16.9693 2.21911 17.458 2.57715C18.4607 3.31206 18.5676 4.54422 18.5693 4.56445L18.5703 4.58203L18.5742 4.59863L19.6904 9.75H4.30957L5.42578 4.59863L5.42969 4.58203L5.43066 4.56445C5.43234 4.54439 5.53922 3.31211 6.54199 2.57715C7.03072 2.21911 7.8055 2.18268 8.67383 2.33398C9.52732 2.48271 10.4021 2.79991 11.0273 3.06152C11.6502 3.32206 12.3498 3.32206 12.9727 3.06152C13.5979 2.79991 14.4727 2.48271 15.3262 2.33398Z"
        />
      </clipPath>
      <clipPath :id="`${componentId}_bgblur_1_4224_1631_clip_path`" transform="translate(-1.66275 -12.6627)">
        <path
          d="M3.13477 13.25H20.8652C21.3713 13.25 21.7498 13.6271 21.75 14.0547V14.9121C21.75 15.9237 21.3178 16.8978 20.542 17.6191C19.7654 18.3411 18.7081 18.75 17.6025 18.75C16.4971 18.7499 15.4406 18.341 14.6641 17.6191C13.8882 16.8978 13.4561 15.9238 13.4561 14.9121V14.6621H10.5439V14.9121C10.5439 15.9238 10.1118 16.8978 9.33594 17.6191C8.55943 18.341 7.5029 18.7499 6.39746 18.75C5.29192 18.75 4.23459 18.3411 3.45801 17.6191C2.68223 16.8978 2.25001 15.9237 2.25 14.9121V14.0547C2.25015 13.6271 2.62875 13.25 3.13477 13.25Z"
        />
      </clipPath>
      <clipPath :id="`${componentId}_bgblur_2_4224_1631_clip_path`" transform="translate(-0.662745 -9.66275)">
        <path
          d="M2 10.25H22C22.4142 10.25 22.75 10.5858 22.75 11C22.75 11.4142 22.4142 11.75 22 11.75H2C1.58579 11.75 1.25 11.4142 1.25 11C1.25 10.5858 1.58579 10.25 2 10.25Z"
        />
      </clipPath>
      <linearGradient
        :id="`${componentId}_paint0_linear_4224_1631`"
        x1="17.6"
        y1="11"
        x2="4.62723"
        y2="21.1747"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#FC3BB2" />
        <stop offset="1" stop-color="#F7906E" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint1_linear_4224_1631`"
        x1="6.54694"
        y1="2.93201"
        x2="10.1712"
        y2="11.9096"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint2_linear_4224_1631`"
        x1="5.18367"
        y1="13.699"
        x2="6.9753"
        y2="21.0956"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
      <linearGradient
        :id="`${componentId}_paint3_linear_4224_1631`"
        x1="4.50204"
        y1="10.233"
        x2="4.6926"
        y2="12.8292"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="white" stop-opacity="0.25" />
        <stop offset="1" stop-color="white" stop-opacity="0" />
      </linearGradient>
    </defs>
  </svg>
</template>

<script>
export default {
  props: {
    componentId: {
      type: String,
      default: ''
    }
  }
}
</script>
